<script setup lang="ts">
import type { CmsSectionDefault } from "@shopware/composables";
import { getCmsLayoutConfiguration } from "@shopware/helpers";

const props = defineProps<{
  content: CmsSectionDefault;
}>();

const { cssClasses, layoutStyles } = getCmsLayoutConfiguration(props.content);
</script>

<template>
  <section class="cms-section-default" :class="cssClasses" :styles="layoutStyles">
    <div 
      :class="{
        'container': layoutStyles.sizingMode === 'boxed',
        'container-full': layoutStyles.sizingMode === 'full_width',
      }"
    >
      <CmsGenericBlock
        v-for="cmsBlock in content.blocks"
        :key="cmsBlock.id"
        :content="cmsBlock"
      />
    </div>
  </section>
</template>
